import { freeze } from 'icepick';
import { SET, type SetAction } from './actions.tsx';
import type { AnalyticsData } from './types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type AnalyticsDataState = AnalyticsData;

export const initialState: AnalyticsDataState = {
	projectType: '',
};

type Action = SetAction;

const analyticsData = (
	state: AnalyticsDataState = initialState,
	action: Action,
): AnalyticsDataState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		default:
			return state;
	}
};

export default analyticsData;
